import { PayloadAction, createSlice } from "@reduxjs/toolkit"

export enum SlideOverType {
  NONE = 0,
  BILLING_PLAN_SELECT = 1,
}

export interface SlideOverAppState {
  sheet: SlideOverType
}

const initialState: SlideOverAppState = {
  sheet: SlideOverType.NONE,
}

const slideOverSlice = createSlice({
  name: "slideOver",
  initialState,
  reducers: {
    setSlideOver: (state, action: PayloadAction<SlideOverType>) => {
      state.sheet = action.payload
    },
    dismissSlideOver: (state) => {
      state.sheet = SlideOverType.NONE
    },
  },
})

export const { setSlideOver, dismissSlideOver } = slideOverSlice.actions
export const SlideOverReducer = slideOverSlice.reducer
